import * as React from 'react';
import { DialogStateContext } from './dialog-state';
import { DialogControlContext } from './dialog-control';
/**
 *
 * @param id the unique ID you would like to associate with this dialog
 * @param dialogQueryKey optional unique key in query parameter you would like to use in url with dialog pop up
 * @returns [isOpen, dialogActions, DialogComponent]
 */
export var useDialog = function (id, dialogQueryKey) {
    if (dialogQueryKey === void 0) { dialogQueryKey = 'pwaDialog'; }
    var _a = React.useContext(DialogStateContext), openedDialogs = _a.openedDialogs, open = _a.open, close = _a.close;
    var useDialogControl = React.useContext(DialogControlContext).useDialogControl;
    var dialogId = id + "_" + dialogQueryKey;
    var isOpen = openedDialogs.includes(dialogId);
    var setIsOpen = React.useCallback(function (isOpen) {
        if (isOpen) {
            open(dialogId);
        }
        else {
            close(dialogId);
        }
    }, [open, close, dialogId]);
    var _b = useDialogControl(id, dialogQueryKey, isOpen, setIsOpen), actions = _b.actions, ComponentFactory = _b.ComponentFactory;
    return [isOpen, actions, ComponentFactory];
};
//# sourceMappingURL=use-dialog.js.map